import { useRemoteStrings } from '@acorns/web-utils'
import React from 'react'
import { TestIDs } from 'test/utils/testIds'
import { Button } from '@acorns/grove'

interface Props {
  handleClick: () => void // function that is triggered with clicking skip button (auto adds button if provided)
  title?: string
}

export const SkipButton = (props: Props) => {
  const { getRemoteString } = useRemoteStrings()

  return (
    <Button
      testId={TestIDs.NAVIGATION_BAR.SKIP_BUTTON}
      onClick={props.handleClick}
      inkOpacity={0.02}
      secondary
    >
      {props.title ? props.title : getRemoteString({ key: 'global.skip' })}
    </Button>
  )
}
